module.exports = __webpack_public_path__ + "static/img/5.e649ea6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fu_shenfree/5.png
// module id = 0muc
// module chunks = 0